var _excluded = ["contentWidth", "contentPadding", "contentSize", "trigger", "children", "disableArrow"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from "react";
import PropTypes from "prop-types";
import { useTooltip, TooltipPopup } from "@reach/tooltip";
import Portal from "@reach/portal"; // taken from https://github.com/reach/reach-ui/blob/master/packages/tooltip/examples/triangle.example.js
// Center the tooltip, but collisions will win

var centered = function centered(triggerRect, tooltipRect) {
  var triggerCenter = triggerRect.left + triggerRect.width / 2;
  var left = triggerCenter - tooltipRect.width / 2;
  var maxLeft = window.innerWidth - tooltipRect.width - 2;
  return {
    left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
    top: triggerRect.bottom + 8 + window.scrollY
  };
}; // eslint-disable-next-line react/prop-types


var TriangleTooltip = function TriangleTooltip(_ref) {
  var children = _ref.children,
      label = _ref.label,
      ariaLabel = _ref.ariaLabel,
      contentWidth = _ref.contentWidth,
      contentPadding = _ref.contentPadding,
      contentSize = _ref.contentSize,
      disableArrow = _ref.disableArrow;

  // get the props from useTooltip
  var _useTooltip = useTooltip(),
      _useTooltip2 = _slicedToArray(_useTooltip, 2),
      trigger = _useTooltip2[0],
      tooltip = _useTooltip2[1]; // destructure off what we need to position the triangle


  var isVisible = tooltip.isVisible,
      triggerRect = tooltip.triggerRect;
  var extra_props = disableArrow ? {} : {
    position: centered
  };
  var children_trigger = typeof children === "string" ? /*#__PURE__*/React.createElement("span", null, children) : children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children_trigger, trigger), isVisible && !disableArrow &&
  /*#__PURE__*/
  // The Triangle. We position it relative to the trigger, not the popup
  // so that collisions don't have a triangle pointing off to nowhere.
  // Using a Portal may seem a little extreme, but we can keep the
  // positioning logic simpler here instead of needing to consider
  // the popup's position relative to the trigger and collisions
  React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: "et--tooltip2--arrow",
    style: {
      left: triggerRect && triggerRect.left - 10 + triggerRect.width / 2,
      top: triggerRect && triggerRect.bottom + window.scrollY
    }
  })), /*#__PURE__*/React.createElement(TooltipPopup, _extends({}, tooltip, {
    label: label,
    ariaLabel: ariaLabel,
    className: "et--tooltip2",
    style: {
      padding: contentPadding,
      width: contentWidth,
      fontSize: contentSize
    }
  }, extra_props)));
};

var Tooltip2 = function Tooltip2(_ref2) {
  var contentWidth = _ref2.contentWidth,
      _ref2$contentPadding = _ref2.contentPadding,
      contentPadding = _ref2$contentPadding === void 0 ? "15px" : _ref2$contentPadding,
      _ref2$contentSize = _ref2.contentSize,
      contentSize = _ref2$contentSize === void 0 ? "14px" : _ref2$contentSize,
      trigger = _ref2.trigger,
      children = _ref2.children,
      disableArrow = _ref2.disableArrow,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(TriangleTooltip, _extends({
    label: children,
    contentWidth: contentWidth,
    contentPadding: contentPadding,
    contentSize: contentSize,
    disableArrow: disableArrow
  }, rest), trigger);
};

Tooltip2.propTypes = {
  contentWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  contentPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  contentSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  trigger: PropTypes.any,
  children: PropTypes.any,
  disableArrow: PropTypes.bool
};
export default Tooltip2;